import { EntityRepository, Repository } from "typeorm";
import { ExpensesLogisticsEntity } from "../dto/expenses-logistics-entity";


@EntityRepository(ExpensesLogisticsEntity)
export class ExpensesLogisticsRepo extends Repository<ExpensesLogisticsEntity> {
    
}